// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3MMwv","image":"Header_image__2Rqmb","name":"Header_name__LR8uj","info":"Header_info__yYZXA","infoRow":"Header_infoRow___fo8o"};